import { Box, Container, Typography } from "@mui/material";

import DryCleaningIcon from "@mui/icons-material/DryCleaning";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import VerifiedIcon from "@mui/icons-material/Verified";

import processBg from "../../assets/images/process_bg.png";
import processBgm from "../../assets/images/process_bg_m.png";
import cardBg from "../../assets/images/process_bg_c.png";

const processSteps = [
  {
    number: "01",
    title: "Schedule Pickup",
    description:
      "Book your pickup through phone, WhatsApp or our contact form.",

    icon: <LocalShippingIcon />,
  },

  {
    number: "02",
    title: "We Collect",
    description: "Our team collects your garments from your home or office.",

    icon: <Inventory2Icon />,
  },

  {
    number: "03",
    title: "Expert Cleaning",
    description:
      "Professional cleaning, stain treatment and quality inspection.",

    icon: <DryCleaningIcon />,
  },

  {
    number: "04",
    title: "Delivered Fresh",
    description: "Fresh, perfectly cleaned garments delivered back to you.",

    icon: <VerifiedIcon />,
  },
];
export default function OurProcess() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        position: "relative",

        overflow: "hidden",

        backgroundImage: {
          xs: ` url(${processBgm})`,
          md: ` url(${processBg})`,
        },
        backgroundSize: "cover",

        backgroundPosition: { xs: "left bttom", md: "bottom" },
      }}
    >
      <Container maxWidth="xl">
        {/* HEADER */}

        <Box
          sx={{
            textAlign: "center",

            maxWidth: "900px",

            mx: "auto",
          }}
        >
          <Box
            sx={{
              display: "inline-flex",

              px: 2.5,

              py: 1,

              borderRadius: "50px",

              background: "rgba(0,87,255,.08)",

              color: "#0057FF",

              fontSize: "12px",

              fontWeight: 800,

              letterSpacing: "1px",

              textTransform: "uppercase",
            }}
          >
            Our Process
          </Box>

          <Typography
            sx={{
              mt: 2.5,

              fontWeight: 900,

              lineHeight: 1.05,

              color: "#07122F",
              fontSize: {
                xs: "32px",
                sm: "32px",
                md: "56px",
                lg: "56px",
              },
            }}
          >
            Simple, Convenient &
            <br />
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              Professional Service
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 2,

              color: "#64748B",

              lineHeight: 1.8,

              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "16px",
              },
            }}
          >
            From pickup to delivery, every step is designed to provide a smooth,
            reliable and hassle-free experience for cleaning, repairs,
            alterations, printing and specialty care services.
          </Typography>
        </Box>

        {/* PROCESS CARDS */}

        <Box
          sx={{
            mt: {
              xs: 5,
              md: 8,
            },

            display: "flex",

            flexWrap: "wrap",

            justifyContent: "center",

            gap: {
              xs: 2,
              md: 3,
            },
          }}
        >
          {processSteps.map((step) => (
            <Box
              key={step.number}
              sx={{
                flex: {
                  xs: "1 1 100%",
                  sm: "1 1 calc(50% - 12px)",
                  lg: "1 1 calc(25% - 18px)",
                },

                maxWidth: {
                  xs: "100%",
                  sm: "calc(50% - 12px)",
                  lg: "calc(25% - 18px)",
                },

                position: "relative",

                minHeight: {
                  xs: 160,
                  md: 210,
                },

                p: {
                  xs: 2.2,
                  md: 2.8,
                },

                borderRadius: "24px",

                overflow: "hidden",

                backgroundImage: `
        //   linear-gradient(
        //     rgba(255,255,255,.92),
        //     rgba(248,251,255,.86)
        //   ),
          url(${cardBg})
        `,

                backgroundSize: "cover",
                backgroundPosition: "center",

                border: "1px solid rgba(255,255,255,.85)",

                backdropFilter: "blur(18px)",

                boxShadow: "0 12px 35px rgba(0,87,255,.08)",

                transition: ".35s",

                "&::before": {
                  content: '""',

                  position: "absolute",

                  left: 0,

                  top: 18,

                  bottom: 18,

                  width: "4px",

                  borderRadius: "20px",

                  background: "linear-gradient(180deg,#0057FF,#1DB6FF)",
                },

                "&:hover": {
                  transform: "translateY(-8px)",

                  boxShadow: "0 25px 60px rgba(0,87,255,.15)",
                },
              }}
            >
              {/* NUMBER */}

              <Typography
                sx={{
                  position: "absolute",

                  top: 14,

                  right: 18,

                  fontWeight: 900,

                  fontSize: {
                    xs: "44px",
                    md: "58px",
                  },

                  color: "rgba(0,87,255,.08)",

                  lineHeight: 1,
                }}
              >
                {step.number}
              </Typography>

              {/* ICON */}

              <Box
                sx={{
                  width: {
                    xs: 52,
                    md: 60,
                  },

                  height: {
                    xs: 52,
                    md: 60,
                  },

                  borderRadius: "18px",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  color: "#fff",

                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  boxShadow: "0 12px 30px rgba(0,87,255,.22)",

                  mb: 2,

                  "& svg": {
                    fontSize: {
                      xs: 24,
                      md: 28,
                    },
                  },
                }}
              >
                {step.icon}
              </Box>

              {/* TITLE */}

              <Typography
                sx={{
                  fontWeight: 800,

                  color: "#07122F",

                  fontSize: {
                    xs: "18px",
                    md: "22px",
                  },
                }}
              >
                {step.title}
              </Typography>

              {/* DESCRIPTION */}

              <Typography
                sx={{
                  mt: 1,

                  color: "#64748B",

                  lineHeight: 1.7,

                  fontSize: {
                    xs: "13px",
                    md: "15px",
                  },
                }}
              >
                {step.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
